import ConsumerCard from './ConsumerCard';
export default ConsumerCard;
